import React from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import { graphql } from "gatsby"
import BioInfoLanding from "../components/landing-page/bio-info"
import { Parallax } from "react-scroll-parallax"
import AboutMe from "../components/landing-page/about-me"
import BlogFeed from "../components/landing-page/blog-feed"

const IndexPage = props => {
  const [theme] = React.useState(
    typeof window !== `undefined` &&
      window.localStorage.getItem("darkMode") === "true"
      ? true
      : false
  )

  const { data } = props

  return (
    <Layout location={props.location} darkMode={theme}>
      <SEO
        title="Sameera Madushan"
        keywords={data.site.siteMetadata.keywords}
        image={{
          src: data.site.siteMetadata.siteUrl + "/index-seo.png",
          height: 628,
          width: 1200,
        }}
      />

      <Parallax y={[-20, 10]} tagOuter="figure">
        <BioInfoLanding />
      </Parallax>

      <AboutMe />

      <Parallax y={[-10, 0]} tagOuter="figure">
        <BlogFeed />
      </Parallax>
    </Layout>
  )
}

export default IndexPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        siteUrl
        keywords
      }
    }
  }
`
